
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/json-diff",
      function () {
        return require("private-next-pages/json-diff.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/json-diff"])
      });
    }
  